//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { EditorMenuBubble } from 'tiptap';
import Tooltip from '@nextcloud/vue/dist/Directives/Tooltip';
export default {
  name: 'MenuBubble',
  components: {
    EditorMenuBubble: EditorMenuBubble
  },
  directives: {
    tooltip: Tooltip
  },
  props: {
    editor: {
      type: Object,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      linkUrl: null,
      linkMenuIsActive: false
    };
  },
  methods: {
    showLinkMenu: function showLinkMenu(attrs) {
      var _this = this;

      this.linkUrl = attrs.href;
      this.linkMenuIsActive = true;
      this.$nextTick(function () {
        _this.$refs.linkInput.focus();
      });
    },
    hideLinkMenu: function hideLinkMenu() {
      this.linkUrl = null;
      this.linkMenuIsActive = false;
    },
    setLinkUrl: function setLinkUrl(command, url) {
      if (url && !url.match(/^[a-zA-Z]+:\/\//) && !url.match(/^\//)) {
        url = 'https://' + url;
      }

      command({
        href: url
      });
      this.hideLinkMenu();
    }
  }
};